export default {
  users: [],
  user: {},
  pagination: {}
};
